import { html } from 'htm/preact'
import { useState } from 'preact/hooks'
import { authService } from '../services/api.js'

export function LoginModal({ isOpen, onClose, onLoginSuccess }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await authService.login(username, password)
      setUsername('')
      setPassword('')
      onLoginSuccess()
      onClose()
    } catch (err) {
      if (err.response?.status === 401) {
        setError('Utilizator sau parolă incorectă')
      } else {
        setError('Eroare de conectare. Încercați din nou.')
      }
    } finally {
      setLoading(false)
    }
  }

  if (!isOpen) return null

  return html`
    <div class="fixed inset-0 z-50 overflow-y-auto" onClick=${onClose}>
      <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:p-0">
        <!-- Background overlay -->
        <div class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75 dark:bg-gray-900 dark:bg-opacity-75"></div>

        <!-- Modal panel -->
        <div 
          class="relative z-50 inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white dark:bg-gray-800 shadow-xl rounded-lg"
          onClick=${(e) => e.stopPropagation()}
        >
          <div class="flex items-center justify-between mb-4">
            <h3 class="text-lg font-medium text-gray-900 dark:text-white">
              🔐 Autentificare
            </h3>
            <button
              onClick=${onClose}
              class="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
            >
              ✕
            </button>
          </div>

          <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">
            Autentificați-vă pentru a putea evalua articolele.
          </p>

          <form onSubmit=${handleSubmit}>
            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Utilizator
              </label>
              <input
                type="text"
                value=${username}
                onInput=${(e) => setUsername(e.target.value)}
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg 
                       bg-white dark:bg-gray-700 text-gray-900 dark:text-white 
                       focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                placeholder="Introduceți utilizatorul"
                required
                disabled=${loading}
              />
            </div>

            <div class="mb-4">
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Parolă
              </label>
              <input
                type="password"
                value=${password}
                onInput=${(e) => setPassword(e.target.value)}
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg 
                       bg-white dark:bg-gray-700 text-gray-900 dark:text-white 
                       focus:ring-2 focus:ring-primary-500 focus:border-transparent"
                placeholder="Introduceți parola"
                required
                disabled=${loading}
              />
            </div>

            ${error && html`
              <div class="mb-4 p-3 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-lg">
                <p class="text-sm text-red-600 dark:text-red-400">${error}</p>
              </div>
            `}

            <div class="flex justify-end gap-3">
              <button
                type="button"
                onClick=${onClose}
                class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 
                       bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600"
                disabled=${loading}
              >
                Anulare
              </button>
              <button
                type="submit"
                class="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-lg 
                       hover:bg-primary-700 focus:ring-2 focus:ring-primary-500 
                       disabled:opacity-50 disabled:cursor-not-allowed"
                disabled=${loading}
              >
                ${loading ? 'Se conectează...' : 'Conectare'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  `
}
